import minBy from 'lodash.minby';

export function getAnchorIndex(list, offset = 0, mobile) {
	if (window.scrollY === 0) return 0;
	const min = minBy(list, (anchor) => {
		let y;
		if (mobile) {
			if (anchor.id === 'PosterPage') {
				y = Math.round(anchor.getBoundingClientRect().top + 0);
			} else if (anchor.id === 'MainPage') {
				y = Math.round(anchor.getBoundingClientRect().top + 200);
			} else if (anchor.id === 'LivePage') {
				y = Math.round(anchor.getBoundingClientRect().top + 350);
			} else if (anchor.id === 'V360Page') {
				y = Math.round(anchor.getBoundingClientRect().top + 500);
			} 
			// else if (anchor.id === 'VdPage') {
			// 	y = Math.round(anchor.getBoundingClientRect().top + 600);
			// } 
			else if (anchor.id === 'features') {
				y = Math.round(anchor.getBoundingClientRect().top + 800);
			} else {
				y = Math.round(anchor.getBoundingClientRect().top + 0);
			}
		} else {
			y = Math.round(anchor.getBoundingClientRect().top + offset);
		}
		if (y > 0) y = 9999999999;
		return Math.abs(y);
	});
	return list.findIndex((option) => {
		if (option.anchor) return option.anchor === min.id;
		return option.id === min.id;
	});
}
